import { Group, Box, Tooltip } from '@mantine/core';
import type { OverviewMilestoneProgress } from '../../../../types';
import { MILESTONE_STATUS_CONFIG } from '../../../../config/statusConfig';

interface MilestoneProgressBarProps {
  milestones: OverviewMilestoneProgress[];
}

export function MilestoneProgressBar({
  milestones,
}: MilestoneProgressBarProps) {
  if (milestones.length === 0) {
    return null;
  }

  const getSegmentColor = (
    status: OverviewMilestoneProgress['status']
  ): string => {
    return MILESTONE_STATUS_CONFIG[status]?.color ?? 'var(--mantine-color-gray-3)';
  };

  return (
    <Group gap={4} style={{ width: '100%' }}>
      {milestones.map(milestone => (
        <Tooltip
          key={milestone.phaseId}
          label={`${milestone.phaseName}: ${milestone.tasksCompleted}/${milestone.tasksTotal} tasks (${milestone.progressPercent}%)`}
          withArrow
        >
          <Box
            style={{
              flex: 1,
              height: 8,
              borderRadius: 4,
              backgroundColor: getSegmentColor(milestone.status),
              transition: 'background-color 0.2s ease',
              cursor: 'pointer',
            }}
          />
        </Tooltip>
      ))}
    </Group>
  );
}

export default MilestoneProgressBar;
